<template>
  <v-dialog v-model="trigger" max-width="768" persistent>
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        Cálculo de precio
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel" class="white--text" icon outlined>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid class="mt-4" v-if="product != null">
          <v-card outlined>
            <v-card-title class="text-subtitle-1 font-weight-bold pb-2">
              Acrónimos
            </v-card-title>
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="text-left py-1"
                  v-for="(a, i) in acronyms"
                  :key="i"
                  dense
                >
                  <p class="text-caption mb-0">
                    <span class="font-weight-bold">{{ a.acronym }}</span> -
                    {{ a.desc }}
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-card
            class="mt-4 text-left"
            outlined
            v-if="
              this.product != null && this.product.familia === 'panel_ternium'
            "
          >
            <v-card-title class="text-subtitle-1 font-weight-bold pb-2">
              VAF para {{ product.tipo_panel }} de grosor
              {{ product.grosor_seleccionado.referencia }} en
              {{ currentState }}
              {{ currentDestiny }}
            </v-card-title>
            <v-card-text>
              {{ flete }}
            </v-card-text>
          </v-card>
          <v-card outlined class="mt-4">
            <v-card-title class="text-subtitle-1 font-weight-bold pb-2">
              Cálculos
            </v-card-title>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6" class="text-left py-0">
                  <p class="text-caption font-weight-bold mb-0">
                    Precio Provicional 1
                  </p>
                  <p class="text-caption mb-0">PP1 = PL / FM2</p>
                  <p class="text-caption">
                    {{ product.precio_lista }}
                    /
                    {{ product.factores.metro_cuadrado.valor }}
                    = {{ product.precio_provicional_uno }}
                  </p>
                </v-col>
                <v-col cols="12" md="6" class="text-left py-0">
                  <p class="text-caption font-weight-bold mb-0">
                    Precio Provicional 2
                  </p>
                  <p class="text-caption mb-0">PP2 = PP1 * DESCUENTO</p>
                  <p class="text-caption">
                    {{ product.precio_provicional_uno }}
                    *
                    {{ product.descuento_seleccionado }}% =
                    {{ product.precio_provicional_dos }}
                  </p>
                </v-col>
                <v-col cols="12" md="6" class="text-left py-0">
                  <p class="text-caption font-weight-bold mb-0">
                    Flete Provicional
                  </p>
                  <p class="text-caption mb-0">(VAF * FKG) / FM2</p>
                  <p class="text-caption">
                    ({{ flete }} * {{ product.factores.kilogramo.valor }} ) /
                    {{ product.factores.metro_cuadrado.valor }} =
                    {{ product.flete_provicional }}
                  </p>
                </v-col>
                <v-col cols="12" md="6" class="text-left py-0">
                  <p class="text-caption font-weight-bold mb-0">
                    Precio Unitario Final
                  </p>
                  <p class="text-caption mb-0">(PP2 + FP) * LARGO</p>
                  <p class="text-caption">
                    ({{ product.precio_provicional_dos }} +
                    {{ product.flete_provicional }} ) * {{ product.largo }} =
                    {{ product.precio_unitario_final }}
                  </p>
                </v-col>
                <v-col cols="12" md="6" class="text-left py-0">
                  <p class="text-caption font-weight-bold mb-0">Total Local</p>
                  <p class="text-caption mb-0">PUF * CANTIDAD</p>
                  <p class="text-caption">
                    {{ product.precio_unitario_final }} *
                    {{ product.cantidad }} =
                    {{ product.total_local }}
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel"> <v-icon>mdi-check</v-icon>Aceptar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    product: Object,
    trigger: Boolean,
  },
  data() {
    return {
      acronyms: [
        {
          acronym: "VAF",
          desc: "Valor Absoluto de Flete",
        },
        {
          acronym: "PL",
          desc: "Precio de Lista",
        },
        {
          acronym: "PP1",
          desc: "Precio Provisional 1",
        },
        {
          acronym: "PP2",
          desc: "Precio Provisional 2",
        },
        {
          acronym: "FP",
          desc: "Flete Provicional",
        },
        {
          acronym: "PUF",
          desc: "Precio Unitario Final",
        },
        {
          acronym: "TL",
          desc: "Total Local",
        },
        {
          acronym: "FKG",
          desc: "Factor Kilogramo",
        },
        {
          acronym: "FM2",
          desc: "Factor de Metro Cuadrado",
        },
      ],
    };
  },
  computed: {
    flete() {
      const destiny = this.$store.state.destinies.selectedDestiny;

      if (this.product != null && this.product.familia === "panel_ternium") {
        if (this.product?.tipo_panel === "techo") {
          switch (this.product?.grosor_seleccionado?.grosor) {
            case 1:
              return destiny?.attributes?.fletes_techo?.una;
            case 1.5:
              return destiny?.attributes?.fletes_techo?.una_y_media;
            case 2:
              return destiny?.attributes?.fletes_techo?.dos;
            case 2.5:
              return destiny?.attributes?.fletes_techo?.dos_y_media;
            case 3:
              return destiny?.attributes?.fletes_techo?.tres;
            case 4:
              return destiny?.attributes?.fletes_techo?.cuatro;
            case 5:
              return destiny?.attributes?.fletes_techo?.cinco;
            case 6:
              return destiny?.attributes?.fletes_techo?.seis;
            default:
              this.$toasted.show(
                `El producto ${this.product?.descripcion} tiene errores en su configuración. No es posible agregarlo a la cotización.`,
                { type: "error" }
              );
              throw new Error(
                "No fue posible asignar el valor de flete. Producto no agregado"
              );
          }
        }

        if (this.product?.tipo_panel === "muro") {
          switch (this.product?.grosor_seleccionado?.grosor) {
            case 1.5:
              return destiny?.attributes?.fletes_muro?.una_y_media;
            case 2:
              return destiny?.attributes?.fletes_muro?.dos;
            case 2.5:
              return destiny?.attributes?.fletes_muro?.dos_y_media;
            case 3:
              return destiny?.attributes?.fletes_muro?.tres;
            case 4:
              return destiny?.attributes?.fletes_muro?.cuatro;
            case 5:
              return destiny?.attributes?.fletes_muro?.cinco;
            case 6:
              return destiny?.attributes?.fletes_muro?.seis;
            default:
              this.$toasted.show(
                `El producto ${this.product?.descripcion} tiene errores en su configuración. No es posible agregarlo a la cotización.`,
                { type: "error" }
              );
              throw new Error(
                "No fue posible asignar el valor de flete. Producto no agregado"
              );
          }
        }
      }

      return destiny.attributes.valor_flete ?? 0;
    },
    currentState() {
      return (
        this.$store.state.destinies.selectedDestiny?.attributes?.estado ?? ""
      );
    },
    currentDestiny() {
      return (
        this.$store.state.destinies.selectedDestiny?.attributes?.destino ?? ""
      );
    },
  },
  methods: {
    emitCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>